import classes from "./about.module.css";

const SkillsSection = () => {
  const skills = [
    "JavaScript",
    "HTML",
    "CSS",
    "Python",
    "SQL",
    "JSON",
    "Shell/Bash",
    "MongoDB",
    "Mongoose",
    "AWS",
    "React.js",
    "Next.js",
    "Node.js",
    "Express.js",
    "Sequelize",
    "Firebase",
    "Firebase Auth",
    "API (REST)",
    "VS Code",
    "WebStorm By JetBrains",
    "Git",
    "GitHub",
    "Postman",
    "WordPress",
    "Nodemon",
    "Netlify",
    "Vercel",
    "npm",
    "dotenv",
    "ESLint",
    "Prettier",
    "Chrome DevTools",
    "PM2"
  ];

  // Create pyramid structure: 3, 5, 7, 9, 7 items per row
  const pyramidRows = [
    skills.slice(0, 4), // Top row: 3 items
    skills.slice(3, 9), // Second row: 5 items
    skills.slice(8, 15), // Third row: 7 items
    skills.slice(15, 23), // Fourth row: 9 items
    skills.slice(24, 34), // Bottom row: 7 items
  ];

  return (
    <div className={classes.sectionSkillContainer}>
      <div className={classes.skillList}>
        {pyramidRows.map((row, rowIndex) => (
          <div key={rowIndex} className={classes.skillRow}>
            {row.map((skill, skillIndex) => (
              <div key={skillIndex} className={classes.skillItem}>
                {skill}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkillsSection;
